import { Inject, Injectable } from '@angular/core';
import { BaseActionCreator } from "../../baseActionCreator";
import { ApiResponse } from "../../models";
import { GlobalDataRequest } from "../../models/requests/globalDataRequest";
import { AppStore } from "../../state/appStore";
import { GlobalDataActions } from "../../state/globalData";
import { ActionStatus } from '../../state/shared/actionStatus';
import { HttpAction } from '../../state/shared/httpAction';
import { GlobalDataController } from "./globalDataController";

@Injectable()
export class GlobalDataActionCreator extends BaseActionCreator {

  constructor(
    @Inject(AppStore) public appStore: AppStore,
    @Inject(GlobalDataController) public globalDataController: GlobalDataController,
  ) {
    super(globalDataController);
  }

  dispatchFetchEntities = (requestModel: GlobalDataRequest) => this.appStore.dispatch(this.fetchEntities(requestModel)) as HttpAction<ApiResponse>;
  fetchEntities(requestModel: GlobalDataRequest): HttpAction<ApiResponse> {

    return this.createHttpAction<ApiResponse>(

      GlobalDataActions.FETCH_GLOBAL_ENTITIES,

      (dispatch, state, callback) => {
        return this.globalDataController.getGlobalData(requestModel).subscribe((globalDataResult) => {

          dispatch({ type: GlobalDataActions.GLOBAL_ENTITIES_LOADED, payload: globalDataResult });

          callback(new ActionStatus(true, globalDataResult));
        })
      }
    );
  }

  dispatchRequestGlobalSettings = (requestModel: GlobalDataRequest) => this.appStore.dispatch(this.requestGlobalSettings(requestModel)) as HttpAction<ApiResponse>;
  requestGlobalSettings(requestModel: GlobalDataRequest): HttpAction<ApiResponse> {
    return this.createHttpAction<ApiResponse>(

      GlobalDataActions.REQUEST_GLOBAL_SETTINGS,

      (dispatch, state, callback) => {

        return this.globalDataController.getGlobalData(requestModel).subscribe((globalDataResponse) => {

          dispatch({ type: GlobalDataActions.GLOBAL_SETTINGS_LOADED, payload: globalDataResponse });

          // Update complete request status
          callback(new ActionStatus(true, globalDataResponse));
        })
      });
  }

  dispatchRequestLocalizeData = (requestModel: GlobalDataRequest) => this.appStore.dispatch(this.requestLocalizeData(requestModel)) as HttpAction<ApiResponse>;
  requestLocalizeData(requestModel: GlobalDataRequest): HttpAction<ApiResponse> {
    return this.createHttpAction<ApiResponse>(

      GlobalDataActions.REQUEST_LOCALIZE_DATA,

      (dispatch, state, callback) => {

        return this.globalDataController.getGlobalData(requestModel).subscribe((globalDataResponse) => {

          dispatch({ type: GlobalDataActions.LOCALIZE_DATA_LOADED, payload: globalDataResponse });

          // Update complete request status
          callback(new ActionStatus(true, globalDataResponse));
        })
      });
  }

  dispatchRequestWebSettings = () => this.appStore.dispatch(this.requestWebSettings()) as HttpAction<ApiResponse>;
  requestWebSettings(): HttpAction<ApiResponse> {
    return this.createHttpAction<ApiResponse>(

      GlobalDataActions.REQUEST_WEB_SETTINGS,

      (dispatch, state, callback) => {

        return this.globalDataController.getWebSettings().subscribe((webSettingsResponse) => {

          dispatch({ type: GlobalDataActions.WEB_SETTINGS_LOADED, payload: webSettingsResponse });

          // Update complete request status
          callback(new ActionStatus(true, webSettingsResponse));
        })
      });
  }

  dispatchRequestUISettings = () => this.appStore.dispatch(this.requestUISettings()) as HttpAction<ApiResponse>;
  requestUISettings(): HttpAction<ApiResponse> {
    return this.createHttpAction<ApiResponse>(

      GlobalDataActions.REQUEST_UI_SETTINGS,

      (dispatch, state, callback) => {

        return this.globalDataController.getUISettings().subscribe((uiSettingsResponse) => {

          dispatch({ type: GlobalDataActions.UI_SETTINGS_LOADED, payload: uiSettingsResponse });

          // Update complete request status
          callback(new ActionStatus(true, uiSettingsResponse));
        })
      });
  }
}